import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=1c1db3ad&scoped=true"
import script from "./IconGroup.vue?vue&type=script&lang=js"
export * from "./IconGroup.vue?vue&type=script&lang=js"
import style0 from "./IconGroup.vue?vue&type=style&index=0&id=1c1db3ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1db3ad",
  null
  
)

export default component.exports